module.exports = __webpack_public_path__ + "img/map_5_click.583b06fd.svg";